import {create} from 'zustand';
import CommunicationModalsService, {
  CommunicationModal,
} from '../services/CommunicationModalsService/CommunicationModalsService';

interface CommunicationModalStoreState {
  queue: CommunicationModal[];
  activeModal: CommunicationModal | null;
  isFetching: boolean;
  isDismissing: boolean;
  fetchModals: () => Promise<void>;
  dismissActive: () => Promise<void>;
  clear: () => void;
}

export const useCommunicationModalStore = create<CommunicationModalStoreState>(
  (set, get) => ({
    queue: [],
    activeModal: null,
    isFetching: false,
    isDismissing: false,

    fetchModals: async () => {
      // O useEffect de user?.clientCode pode disparar mais de uma vez;
      // evita clobberar uma fila já em exibição/carregamento.
      if (get().isFetching || get().activeModal) {
        return;
      }
      set({isFetching: true});
      try {
        const modals =
          await CommunicationModalsService.GetActiveCommunicationModals();
        if (modals.length === 0) {
          set({queue: [], activeModal: null});
          return;
        }
        set({queue: modals.slice(1), activeModal: modals[0]});
      } catch (error) {
        console.error('Failed to fetch communication modals', error);
      } finally {
        set({isFetching: false});
      }
    },

    dismissActive: async () => {
      const current = get().activeModal;
      // Guarda contra toque duplo em "Entendi!": sem isso, dois taps
      // rápidos marcavam o mesmo modal duas vezes e/ou pulavam o próximo.
      if (!current || get().isDismissing) {
        return;
      }
      set({isDismissing: true});

      try {
        await CommunicationModalsService.MarkCommunicationModalViewed(
          current.id,
        );
      } catch (error) {
        console.error('Failed to mark modal as viewed', error);
      }

      const next = get().queue;
      set({
        activeModal: next.length > 0 ? next[0] : null,
        queue: next.slice(1),
        isDismissing: false,
      });
    },

    clear: () =>
      set({queue: [], activeModal: null, isFetching: false, isDismissing: false}),
  }),
);
